import * as ApiUrls from "./ApiUrl.UserActivity";
import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import { UserActivitySearchRequest, UserActivitySearchResponse } from "../../Model/Dto/UserActivity";

export const UserActivityService = {
    searchUserActivity: (searchData: UserActivitySearchRequest): Promise<AxiosResponse<UserActivitySearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.SearchUserActivity, searchData),

    exportSearchResults: (searchData: UserActivitySearchRequest): Promise<AxiosResponse<void>> =>
        axiosCoreInstance.post(ApiUrls.ExportSearchResults, searchData)
};
